<!-- Backdrop overlay para mobile -->
<div *ngIf="isMobile && drawerOpen" class="sidebar-backdrop" (click)="closeDrawer()"></div>

<div class="vertical-menu"
  [ngClass]="{
    'menu-chico': collapsed && !isMobile,
    'sidebar-drawer': isMobile,
    'open': isMobile && drawerOpen,
    'crear-open': isMobile && crearPanelOpen,
    'settings-open': isMobile && settingsPanelOpen
  }">
  <div class="navbar-brand-box" *ngIf="!collapsed">
    <a class="logo logo-light">
      <span class="logo-lg">
        <img src="assets/images/logo-abbr-clear.png" alt="" height="22" />
      </span>
      <i class="icon-arrow-left" (click)="toggleNavigation(true)"></i>
    </a>
  </div>

  <div class="navbar-brand-box menu-collapsed " *ngIf="collapsed">
    <a class="logo">
      <i class="icon-menu" (click)="toggleNavigation(false)"></i>
    </a>
  </div>


  <div>
    <div data-simplebar class="sidebar-menu-scroll">
      <div class="name-bussines" *ngIf="!collapsed">
        <div class="d-flex align-items-center">
          <div class="circle">{{ name.charAt(0) }}</div>
          <div class="d-flex flex-column" [ngClass]="{ 'display1': collapsed}">
            <span>{{ name }}</span>
            <span class="type">{{ account_name }}</span>
          </div>
        </div>
        <a *ngIf="role == 'Admin'" class="has-submenu" (click)="toggleSubmenuConf($event)"
          [ngClass]="{ 'icon-grande': collapsed}" (mouseenter)="cancelCloseTimeoutConf()"
          (mouseleave)="startCloseTimeoutConf()"><i class="icon-cog"></i>
        </a>

      </div>
      <div class="name-bussines-collapsed " *ngIf="collapsed">

        <a *ngIf="role == 'Admin'" class="has-submenu" (click)="toggleSubmenuConf($event)"
          [ngClass]="{ 'icon-grande': collapsed}" (mouseenter)="cancelCloseTimeoutConf()"
          (mouseleave)="startCloseTimeoutConf()"><i class="icon-cog"></i>
        </a>

      </div>
      <div id="sidebar-menu">
        <ul class="metismenu list-unstyled" id="side-menu">
          <div *ngIf="type == 'broker'" id="sidebar-create-menu">
            <li class="has-submenu" (click)="toggleSubmenu($event)" (mouseenter)="cancelCloseTimeout()"
              (mouseleave)="startCloseTimeout()">
              <a class="resaltar" [ngClass]="{ 'justify-content-center' : collapsed}">
                <div class="d-flex">
                  <i class="icon-plus"></i>
                  <span class="menu-item" data-key="t-submenu" [ngClass]="{ 'display1': collapsed}">
                    {{ "titles-menu-pages.create" | translate }}
                  </span>
                </div>
                <i class="icon-chevron-right" [ngClass]="{ 'display1': collapsed}"></i>
              </a>
            </li>
          </div>
          <li class="menu-title" data-key="t-menu">
            {{ "titles-menu-pages.menu" | translate }}
          </li>
          <li *ngFor="let item of menuItems" class="menu-item-has-children" [hidden]="item.hideOnMobile && isMobile">
            <div *ngIf="!item.role || (item.role && item.role.includes(role))">
              <a class="d-flex"
                [ngClass]="{ 'justify-content-between': !collapsed, 'justify-content-center': collapsed }"
                [routerLink]="item.route || null" (click)="item.children ? toggleSubmenuNav(item.key) : onMenuItemClick()">

                <div class="tooltip-container">
                  <i [class]="item.icon" [ngClass]="{ 'icon-grande': collapsed }"></i>
                  <span class="tooltip-text" [ngClass]="{ 'display1': !collapsed }">
                    {{ item.label | translate }}
                  </span>
                  <span class="menu-item" [attr.data-key]="item.key" [ngClass]="{ 'display1': collapsed }">
                    {{ item.label | translate }}
                  </span>
                </div>

                <i *ngIf="item.children" [ngClass]="{
                     'display1': collapsed,
                     'icon-chevron-up': submenuState[item.key],
                     'icon-chevron-down': !submenuState[item.key],
                     'rotate-icon': submenuState[item.key]
                   }">
                </i>
              </a>

              <ul *ngIf="item.children" class="submenu" [ngClass]="{ 'submenu-open': submenuState[item.key] }">
                <li *ngFor="let child of item.children">
                  <a [routerLink]="child.route" (click)="onMenuItemClick()">
                    <div>
                      <i [class]="child.icon"></i>
                      <span class="menu-item" [attr.data-key]="child.key">
                        {{ child.label | translate }}
                      </span>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="nav-second-level" [ngClass]="{'collapse': submenuOpen, 'collapse2': collapsed, 'crear-panel-mobile': isMobile && crearPanelOpen}"
    [style.top]="isMobile && crearPanelOpen ? crearPanelTop : null"
    (mouseenter)="cancelCloseTimeout()" (mouseleave)="startCloseTimeout()">
    <div class="crear-panel-header" *ngIf="isMobile && crearPanelOpen">
      <span>{{ "titles-menu-pages.create" | translate }}</span>
    </div>
    <div class="row" (mouseenter)="cancelCloseTimeout()" (mouseleave)="startCloseTimeout()">
      <div class="submenuitem" [ngClass]="{'col-6': !isMobile || !crearPanelOpen, 'col-12': isMobile && crearPanelOpen}">
        <a class="subitem-menu" routerLink="/orders/contracts/add" (click)="onMenuItemClick()">
          <i class="icon-clipboard-pencil"></i>
          <span class="menu-item">{{ "titles-menu-pages.order" | translate }}</span>
        </a>
      </div>
      <div class="submenuitem" [ngClass]="{'col-6': !isMobile || !crearPanelOpen, 'col-12': isMobile && crearPanelOpen}">
        <a class="subitem-menu" routerLink="/clients/add" (click)="onMenuItemClick()">
          <i class="icon-user-plus"></i>
          <span class="menu-item">{{ "titles-menu-pages.client" | translate }}</span>
        </a>
      </div>
      <div *ngIf="role != 'Sales'" class="submenuitem" [ngClass]="{'col-6': !isMobile || !crearPanelOpen, 'col-12': isMobile && crearPanelOpen}" [hidden]="isMobile">
        <a class="subitem-menu" routerLink="/invoices/add" (click)="onMenuItemClick()">
          <i class="icon-clipboard-check"></i>
          <span class="menu-item">{{ "titles-menu-pages.invoice" | translate }}</span>
        </a>
      </div>
    </div>
  </div>

  <div class="nav-settings grid-2x2"
    [ngClass]="{'collapse': submenuOpenConf, 'collapse2': collapsed, 'settings-panel-mobile': isMobile && settingsPanelOpen}"
    [style.top]="isMobile && settingsPanelOpen ? settingsPanelTop : null"
    (mouseenter)="cancelCloseTimeoutConf()" (mouseleave)="startCloseTimeoutConf()">
    <div class="settings-panel-header" *ngIf="isMobile && settingsPanelOpen">
      <span>{{ "titles-menu-pages.settings" | translate }}</span>
    </div>
    <div class="row" (mouseenter)="cancelCloseTimeoutConf()" (mouseleave)="startCloseTimeoutConf()">
      <div class="submenuitem col-12">
        <a class="subitem-menu" routerLink="/settings/profile" (click)="onMenuItemClick()">
          <i class="icon-user"></i>
          <span class="menu-item">{{ "settings.profile.cardtitle" | translate }}</span>
        </a>
      </div>
      <div class="submenuitem col-12">
        <a class="subitem-menu" routerLink="/settings" (click)="onMenuItemClick()">
          <i class="icon-cog"></i>
          <span class="menu-item">{{ "titles-menu-pages.settings" | translate }}</span>
        </a>
      </div>
    </div>
  </div>

</div>
